import { useMemo } from 'react';
import { useDevice } from './useDevice';
import type { NASensorDataObject } from '@/api/models';

export interface SensorAvailability {
  hasDC: boolean;
  hasDCTrends: boolean;
  hasAC: boolean;
  hasSecurity: boolean;
  hasSwitches: boolean;
  hasNevata: boolean;
  hasGeofence: boolean;
  hasTenders: boolean;
}

export function useSensorData(): {
  sensorData: NASensorDataObject | null;
  availability: SensorAvailability;
} {
  const { selectedDeviceInfo } = useDevice();

  const sensorData = selectedDeviceInfo?.sensorData ?? null;

  const availability = useMemo<SensorAvailability>(() => {
    if (!sensorData) {
      return {
        hasDC: false,
        hasDCTrends: false,
        hasAC: false,
        hasSecurity: false,
        hasSwitches: false,
        hasNevata: false,
        hasGeofence: false,
        hasTenders: false,
      };
    }

    return {
      hasDC: (sensorData.dcSensorList?.length ?? 0) > 0,
      hasDCTrends: (sensorData.dcTrendList?.length ?? 0) > 0,
      hasAC: (sensorData.acSensorList?.length ?? 0) > 0,
      hasSecurity: (sensorData.securitySensorlist?.length ?? 0) > 0,
      hasSwitches: (sensorData.switchSensorList?.length ?? 0) > 0,
      hasNevata: (sensorData.nevataSensorList?.length ?? 0) > 0,
      hasGeofence: (sensorData.geofenceList?.length ?? 0) > 0,
      hasTenders: (sensorData.tenderList?.length ?? 0) > 0,
    };
  }, [sensorData]);

  return { sensorData, availability };
}
